import React, { useState, useEffect } from "react";
import { Col, Card, Table, Modal, Button, Spinner } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";

function AllRoles() {
  const history = useHistory();
  const [spinner, setSpinner] = useState(true);
  const [addPerm, setAddPermission] = useState(false);
  const [name, setName] = useState("");
  const [permId, setPermId] = useState("");
  const [permission, setPermission] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [deleteRole, setDeleteRole] = useState(false);
  const [updateRole, setUpdateRole] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [getData, setGetData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [permissionList, setPermissionList] = useState([]);
  const Permission = [
    "Dashboard",
    "All Users",
    "User Analytics",
    "Deleted User",
    "Riders",
    "Riders Applied",
    "Blocked Riders",
    "Training",
    "Rider Map View",
    "Rejected Riders",
    "Partners",
    "Applied Partners",
    "Blocked Partners",
    "Add Price",
    "Price List",
    "Taxes",
    "Riders/Clint Commission",
    "AllOrders",
    "Geofences",
    "Create Geofence",
    "All Geofence",
    "All Staff",
    "Roles",
    "Serviceable Area",
    "Banners",
    "Trending Banners",
    "Go One Category",
    "Movers Categories",
    "CashBack",
    "Rider Support",
    "Customer Support",
    "FAQ",
    "App Update",

    "Transactions",

    "Tests",
    "Package Category",
    "Main Category",
    "Packages",
    "Package Banner",

    "Health Centers",
    "Customer Notification",
    "Sub Tests",
    "Rider Register",

    "Go One Coupens",
    "Restaurant Owners",
    "Applied Owners",
    "Blocked Owners",
    "Verified Restaurant",
    "Applied Restaurants",
    "Blocked Restaurants",
    "All Items",
    "Applied Items",
    "All Addons",
    "Applied Addons",
    "Quotes",
    "Payment Options",
    "Offers",
    "Food Coupens",
    "Home Category",
    "Food Campaign",
    "Applied Campaign",
    "Food Banner",
    "Banner Campaign Payment",
    "Applied Banners",
    "Delivery Charge",
    "Penalty Restaurants",
    "Order Ratings",

    "Experts List",
    "Applied Experts",
    "Subscription",
    "Service Category",
    "Menu Reviews",
    "AirPort Orders",
    "Rentals Orders",
    "Category Analytics",
    "All Analytics",
    "Airport Assigned Orders",
    "Airport UnAssigned Orders",
    "Rentals Assigned Orders",
    "Rentals UnAssigned Orders",
    "Stores",
    "Sub Store",
    "Products",
    "Grocery Category",
    "Grocery SubCategory",
    "WareHouses",
    "Shop Admin",
    "Gocery Banners"
  ];

  function getRole() {
    axios
      .get(`${Baseurl.baseurl}/roles/get-roles`)
      .then((response) => {
        setSpinner(false);
        setGetData(response.data.details);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  useEffect(() => {
    getRole();
  }, []);
  function deleteRoles() {
    axios
      .delete(`${Baseurl.baseurl}/roles/delete-role/${roleId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Role Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getRole();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function updateRoles() {
    const artical = { updateData: `${name}` };
    axios
      .put(`${Baseurl.baseurl}/roles/update-role/${roleId}`, artical)
      .then((response) => {
        if (response.data.status) {
          setName("");
          swal("Role Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getRole();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    handleClose();
  }
  function deletePermission(val, id) {
    const artical = { permission: `${val}` };
    axios
      .put(`${Baseurl.baseurl}/roles/delete-roles-permission/${id}`, artical)
      .then((response) => {
        if (response.data.status) {
          swal("Permission Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getRole();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function addPermission(val) {
    setPermissionList(
      (oldArray) => oldArray.concat(val),
      () => {}
    );
  }
  function filterPermission(val, id) {
    var array3 = Permission.filter(function (obj) {
      return val.indexOf(obj) == -1;
    });
    setFilterData(array3);
    handleShow();
    setAddPermission(true);
    setUpdateRole(false);
    setDeleteRole(false);
    setPermId(id);
  }
  function removeDuplicates(arr) {
    var counts = arr.reduce(function (counts, item) {
      counts[item] = (counts[item] || 0) + 1;
      return counts;
    }, {});
    return Object.keys(counts).reduce(function (arr, item) {
      if (counts[item] === 1) {
        arr.push(item);
      }
      return arr;
    }, []);
  }
  function updatePermission() {
    var arr = removeDuplicates(permissionList);
    const artical = { permission: arr };
    axios
      .put(`${Baseurl.baseurl}/roles/add-role-permission/${permId}`, artical)
      .then((response) => {
        if (response.data.status) {
          swal("Permission Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setPermissionList("");
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        getRole();
        handleClose();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  return (
    <>
      <Col lg={12}>
        <Modal size="lg" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {deleteRole && <h3>are you sure! want to delete Role</h3>}
              {updateRole && <h3>Update Role Name</h3>}
              {addPerm && <h3>Add Permission</h3>}
            </Modal.Title>
          </Modal.Header>
          {updateRole && (
            <Modal.Body>
              <div className="card">
                <div className="card-body">
                  <div className="basic-form">
                    <form>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Name</label>
                        <div className="col-sm-9">
                          <input
                            value={name}
                            type="text"
                            className="form-control"
                            placeholder="Roll name"
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Modal.Body>
          )}
          {addPerm && (
            <>
              <div className="p-4 row">
                {filterData.map((val) => {
                  return (
                    <div className="col-sm-6">
                      <input
                        onClick={() => addPermission(val)}
                        type="checkbox"
                        className="mb-3"
                        id="checkAll"
                        required
                      />
                      <strong className="ml-4">{val}</strong>
                    </div>
                  );
                })}
              </div>
              {filterData.length === 0 && (
                <h5 className="text-center mb-5">
                  No Permission left to select
                </h5>
              )}
            </>
          )}
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {deleteRole && (
              <Button
                variant="primary"
                onClick={() => {
                  deleteRoles();
                }}
              >
                Yes
              </Button>
            )}
            {updateRole && (
              <Button
                variant="primary"
                onClick={() => {
                  updateRoles();
                }}
              >
                Submit
              </Button>
            )}
            {addPerm && (
              <Button
                variant="primary"
                onClick={() => {
                  updatePermission();
                }}
              >
                Add
              </Button>
            )}
          </Modal.Footer>
        </Modal>
        <Card
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <Card.Header>
            <Card.Title className="text-white">All Roles</Card.Title>
            <div>
              <Link to="./add-roles">
                <button className="btn btn-primary ">Add role</button>
              </Link>
            </div>
          </Card.Header>
          <Card.Body>
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table responsive className="text-white text-center text-sm">
                <thead>
                  <tr>
                    <th>
                      <strong>ROLL NAME</strong>
                    </th>
                    <th>
                      <strong>Permissions</strong>
                    </th>
                    <th>
                      <strong>ADD PERMISSION</strong>
                    </th>
                    <th>
                      <strong>ACTIONS</strong>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-left">
                  {getData.map((d, i) => (
                    <tr>
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="w-space-no">{d.Title}</span>
                        </div>
                      </td>
                      <td className="col-sm-12">
                        {/* {d.Permissions.map((val) => {
                          return (
                            <div className="form-group row mt-3">
                              <div className="col-sm-8">
                                {" "}
                                <strong>{val}</strong>
                              </div>
                              <div className="col-sm-4">
                                <Link
                                  onClick={() => {
                                    deletePermission(val, d._id);
                                  }}
                                  href="#"
                                  className="btn btn-danger shadow btn-xs sharp"
                                >
                                  <i className="fa fa-trash"></i>
                                </Link>
                                
                              </div>
                            </div>
                          );
                        })} */}
                        <div className="form-group row">
                          {d.Permissions.map((val) => {
                            return (
                              <>
                                <div className="col-sm-4 mt-3">
                                  <strong>{val}</strong>
                                </div>
                                <div className="col-sm-2 mt-3">
                                  <Link
                                    onClick={() => {
                                      deletePermission(val, d._id);
                                    }}
                                    href="#"
                                    className="btn btn-danger shadow btn-xs sharp"
                                  >
                                    <i className="fa fa-trash"></i>
                                  </Link>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      </td>
                      <td>
                        <Link
                          onClick={() => {
                            filterPermission(d.Permissions, d._id);
                          }}
                          href="#"
                          className="btn btn-secondary shadow btn-xs sharp ml-5"
                        >
                          <i className="fa fa-plus-square"></i>
                        </Link>
                      </td>
                      <td>
                        <div className="d-flex">
                          <Link
                            onClick={() => {
                              handleShow();
                              setUpdateRole(true);
                              setDeleteRole(false);
                              setAddPermission(false);
                              setRoleId(d._id);
                              setName(d.Title);
                              setPermission(d.Permissions);
                            }}
                            href="#"
                            className="btn btn-primary shadow btn-xs sharp mr-1"
                          >
                            <i className="fa fa-pencil"></i>
                          </Link>
                          <Link
                            onClick={() => {
                              setDeleteRole(true);
                              setUpdateRole(false);
                              setAddPermission(false);
                              handleShow();
                              setRoleId(d._id);
                            }}
                            href="#"
                            className="btn btn-danger shadow btn-xs sharp"
                          >
                            <i className="fa fa-trash"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>
      </Col>
    </>
  );
}

export default AllRoles;
